import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next'
//api
import { createBudget, updateBudget} from 'api/users';
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import FooterModal from 'components/backoffice/modals/FooterModal';
import Input from 'components/backoffice/customInput/index';

const BudgetModalUserLibrary = ({ show, setShow, beforeTitle, idContest, idLibrary,budget, onUpdate}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()
  const {
    formState: { errors },
    reset,
    control,
    handleSubmit,
    setValue
  } = useForm();

  useEffect(() => {
    if (show) {
      setTitle(t('modifyBudget'))
    }
    if (budget !== undefined || budget !== null) {
      setValue('presupuesto', budget?.amount)
    }
  }, [show, budget])


  const handleChangeBudget = async(values) => {
    setIsLoading(true)
    let data = {
      presupuesto: values.presupuesto,
      biblioteca: idLibrary,
      concurso: Number(idContest)
    }
    let data2 = {	
      presupuesto: values.presupuesto,
    }
    try{
      const { status } = budget !== undefined && budget !== null? await updateBudget(budget?.id, data2) : await createBudget(data)
      if ([200, 201].includes(status)) {
        toast.success(t('budgetUpdated'))
        setShow(false)
        onUpdate()
        reset()
      } else {
        toast.error(`${t('error')} ${status}: ${t('errorupdatingbudget')}`, { theme: 'colored' })
      }
    }catch(e){
      console.error(e)
    }
   setIsLoading(false)
  }

  const handleClose = () => {
    setShow(false)
    setTitle(beforeTitle)
    reset()
  }
  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title={t('modifyBudget')}
      footer={<FooterModal onCancel={handleClose} onSave={handleSubmit(handleChangeBudget)} loading={isLoading} />}
    >
      <Form onSubmit={handleSubmit}>
        <Col>
          <Controller
            name="presupuesto"
            control={control}
            rules={{
              required: {
                value: true,
                message: t('camporequerido'),
              },
            }}
            render={({ field: { onChange, value } }) => {
              return <Input type="number" label={t('budget')} onChange={(e) => onChange(e)} value={value} placeholder={t('budget')} min={0}/>
            }
              
            }
          />
          {errors?.presupuesto && <small className="text-danger ">{errors.presupuesto.message}</small>}
        </Col>
      </Form>
    </ModalCustom>
  )
}

BudgetModalUserLibrary.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  beforeTitle: PropTypes.string,
  idContest: PropTypes.number,
  idLibrary: PropTypes.number,
  budget: PropTypes.object,
  onUpdate: PropTypes.func
}
export default BudgetModalUserLibrary
